import { NEW_USER_KEY } from './reducers';

/**
 * Gets the New User app Redux state
 * @param state
 * @returns {*}
 */
export const getNewUserState = state => state.get(NEW_USER_KEY);
